import { HierarchyContextProps, IHierarchyActionAddDomainReplacement } from "./interface";

/**
 * Adds a domain replacement to the hierarchy context state.
 *
 * @param action - The action containing the domain replacement to add
 * @param state - The current hierarchy context state
 * @returns Updated hierarchy context state with the new domain replacement
 */
export const hcr_addDomainReplacement = (
  action: IHierarchyActionAddDomainReplacement,
  state: HierarchyContextProps,
): HierarchyContextProps => {
  if (!state.hierarchy)
    throw `hierarchyContextReducer: ${action.operation}: Hierarchy not assigned yet`;
  return {
    ...state,
    hierarchy: {
      ...state.hierarchy,
      domainReplacements: [...state.hierarchy.domainReplacements, action.domainReplacement],
    },
  };
};
